import { AutoRedemptionSettingStrategy } from '@rd/types/auto-redemption-setting.type';
import { z } from 'zod';

export const autoRedemptionRuleModelSchema = z.object({
  productSku: z.string(),
  enabled: z.boolean(),
  strategies: z.array(z.nativeEnum(AutoRedemptionSettingStrategy)),
});
